import React, { useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { TextInput, TouchableOpacity } from 'react-native-gesture-handler';
import { Text } from 'react-native-web';
import { available_languages_list, done_str, search_language } from '../../../utils/DictionaryManagementUtils';
import SwitcherPanel from './SwitcherPanel';
import BreakLine from '../General/BreakLine';

//= ========================================================================

const SwitcherPanelList = ({
  ArgumentList,
  onConfigChanged,
  setLanguagesBoxOpen,
  isLanguagesBoxOpen,
  default_language,
}) => {
  const myStyle = {
    container: {
      zIndex: 2,
    },
    doneBtn: {
      width: 45,
      height: 22,
      margin: 'auto',
      fontSize: 18,
      fontWeight: 500,
      textAlign: 'center',
      color: 'white',
    },
    doneBtnContainer: {
      zIndex: 3,
      marginTop: -20,
      width: 100,
      height: 40,
      alignSelf: 'flex-end',
      borderRadius: 5,
      backgroundColor: '#008CFF',
    },
    textInputStyle: {
      width: '100%',
      height: 35,
      borderColor: '#cbd5e0',
      border: 'solid 1px #cbd5e0',
      paddingVertical: 10,
      paddingHorizontal: 8,
      borderWidth: 1,
      borderRadius: 4,
      marginBottom: 10,
    },
    switcherListStyle: {
      padding: 8,
    },
  };
  const menuLanguageRef = useRef();
  useEffect(() => {
    const handler = (event) => {
      if (!menuLanguageRef.current.contains(event.target)) {
        setLanguagesBoxOpen(!isLanguagesBoxOpen);
      }
    };
    document.addEventListener('click', handler);
    return () => {
      document.removeEventListener('click', handler);
    };
  });

  const onValueChanged = (key, value) => {
    ArgumentList[key].available = value;
    onConfigChanged();
  };
  const [displayText, setDisplayText] = useState('');
  const [isOnFocus, setIsOnFocus] = useState(false);

  return (
    <View style={myStyle.container}>
      <View ref={menuLanguageRef}>
        <TextInput
          style={myStyle.textInputStyle}
          placeholder={search_language}
          value={displayText}
          selectTextOnFocus
          autoCorrect={false}
          onFocus={() => {
            setIsOnFocus(true);
          }}
          maxLength={15}
          onBlur={() => {
            if (isOnFocus) {
              setIsOnFocus(false);
            }
          }}
          blurOnSubmit={false}
          onChangeText={(newText) => {
            setDisplayText(newText);
          }}
        />
        <View style={myStyle.switcherListStyle}>
          {Object.keys(available_languages_list).filter((languageItem) => available_languages_list[languageItem]
            .includes(displayText) && languageItem in ArgumentList)
            .map((available_language) => (
              <SwitcherPanel
                alwaysOn={default_language === available_language}
                text={available_languages_list[available_language]}
                value={ArgumentList[available_language].available}
                onValueChanged={(value) => {
                  onValueChanged(available_language, value);
                }}
                marginBottom={10}
              />
            ))}
        </View>
      </View>
      <BreakLine marginTop={8} />
      <TouchableOpacity style={myStyle.doneBtnContainer}>
        <Text style={myStyle.doneBtn}>
          {done_str}
        </Text>
      </TouchableOpacity>
    </View>
  );
};
export default SwitcherPanelList;
